import { render, staticRenderFns } from "./InstagramFollowBooster.vue?vue&type=template&id=c3db5f72&scoped=true&"
import script from "./InstagramFollowBooster.vue?vue&type=script&lang=js&"
export * from "./InstagramFollowBooster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3db5f72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3db5f72')) {
      api.createRecord('c3db5f72', component.options)
    } else {
      api.reload('c3db5f72', component.options)
    }
    module.hot.accept("./InstagramFollowBooster.vue?vue&type=template&id=c3db5f72&scoped=true&", function () {
      api.rerender('c3db5f72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/InstagramFollowBooster.vue"
export default component.exports